import React from 'react';
import ex from 'utils/ex';

import './Outlet.css';

export default function Outlet(props) {
  const {
    renderAll = false,
    front: enabled = true,
    category,
    outlets = {},
    pages = [],
    ...rest
  } = props || {};

  return (
    <div
      {...ex('Outlet', rest)}
      {...{
        category,
      }}
    >
      {pages.map((page, index) => {
        const front = enabled && index === pages.length - 1;
        if(!front && !renderAll) return null;
        const inert = !front;
        if (typeof page === 'string') {
          const Component = outlets[page];
          return Component && (
            <div
              key={page || index}
              {...ex({ front }, {
                inert: inert ? '' : undefined,
              })}
            >
              <Component {...{ category, front, renderAll }} />
            </div>
          );
        } else {
          const Component = outlets[page.type || page.name];
          return Component && (
            <div
              key={page.name || index}
              {...ex({ front }, {
                inert: inert ? '' : undefined,
              })}
            >
              <Component {...page.props} {...{ category, front, renderAll }} />
            </div>
          );
        }
      })}
    </div>
  );
}